const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError']

export default events



// WEBPACK FOOTER //
// ./src/components/framework/uploader/common/file-events.js